import "../../assets/css/community-progress.css";
import React from "react";

export function CommunityProgressMenu(props) {
  const { selectedPhase, handleOnChange } = props;

  const phases = [1, 2, 3, 4];
  
  return (
    <div className="community-progress__phases">
      {phases.map((phase, key) => {
        if (phase !== selectedPhase) {
          return(
            <span key={key} className="community-progress__phase" onClick={e => handleOnChange(e, phase)}>{phase}</span>
          );
        } else {
          return(
            <span key={key} className="community-progress__phase community-progress__phase__selected">Phase {phase}</span>
          );
        }
      })}
    </div>
  )

}
  
export default CommunityProgressMenu;